import React from 'react';
import { Modal } from 'react-bootstrap';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import ActionDetailsBody from './ActionDetailsBody';
import { formatActionTask } from './utils/actionTask';
import type { ActionEntity } from './hooks/useScopedActionForm';

type ActionViewModalProps = {
  action: ActionEntity | null;
  show: boolean;
  onClose: () => void;
  canEdit?: boolean;
  onEdit?: (action: ActionEntity) => void;
};

const ActionViewModal: React.FC<ActionViewModalProps> = ({
  action,
  show,
  onClose,
  canEdit = false,
  onEdit,
}) => {
  if (!action) return null;

  const title = formatActionTask(action.name, action.description);

  return (
    <Modal show={show} onHide={onClose} centered scrollable size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title || 'Action Details'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ActionDetailsBody action={action as any} />
      </Modal.Body>
      <Modal.Footer>
        {canEdit && onEdit ? (
          <StylishNewButton
            className="button--primary"
            type="button"
            onClick={() => {
              onClose();
              onEdit(action);
            }}
          >
            Edit
          </StylishNewButton>
        ) : null}
        <StylishNewButton
          className="button--secondary"
          type="button"
          onClick={onClose}
        >
          Close
        </StylishNewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ActionViewModal;
